<template>
  <van-overlay :show="true">
    <div class="init-loading">
      <van-loading type="spinner" color="#FF1979" />
    </div>
  </van-overlay>
</template>

<script setup lang="ts">
import { v7 as uuidv7 } from 'uuid'
import { COOKIE_MAX_AGE } from '#shared/constant'
const route = useRoute()
const returnTo = computed(() => route.query.return_to as string || '/')
definePageMeta({
  layout: false
})

onMounted(async () => {
  console.log('[init-visitor] onMounted 触发, returnTo:', returnTo.value)
  try {
    // Try to recover from localStorage
    const backupGuestId = localStorage.getItem('guest_id_snapshot')
    console.log('[init-visitor] localStorage backupGuestId:', backupGuestId)
    if (backupGuestId) {
      // Restore guest_id to Cookie
      const guestIdCookie = useCookie('guest_id', {
        maxAge: COOKIE_MAX_AGE,
        path: '/',
        sameSite: 'lax'
      })
      guestIdCookie.value = backupGuestId
      console.log('[init-visitor] 已从 localStorage 恢复 guest_id:', backupGuestId)
    } else {
      // Generate new UUID
      const newGuestId = uuidv7()

      // Write to Cookie
      const guestIdCookie = useCookie('guest_id', {
        maxAge: COOKIE_MAX_AGE,
        path: '/',
        sameSite: 'lax'
      })
      guestIdCookie.value = newGuestId

      // Write to localStorage backup
      localStorage.setItem('guest_id_snapshot', newGuestId)

      // Clear old tokens to avoid identity confusion
      useCookie('access_token').value = null
      useCookie('login_info').value = null
      console.log('[init-visitor] 生成新 guest_id:', newGuestId)
    }

    // Redirect back — 用 replace 替换历史记录，后退时不会回到空白页
    console.log('[init-visitor] 准备跳转到:', returnTo.value)
    window.location.replace(returnTo.value)
  } catch (error) {
    console.error('[init-visitor] Init failed:', error)
    window.location.replace(returnTo.value)
  }
})
</script>

<style scoped>
.init-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #fff;
}
</style>
